import { useEffect } from 'react'
import { SharedTaskDetailModal } from '@/components/groups/SharedTaskDetailModal'
import { useSharedGroupStore } from '@/stores/sharedGroupStore'
import type { UnifiedTask } from '@/lib/sharedTypes'

interface SharedTaskDetailPanelProps {
  task: UnifiedTask
  onClose: () => void
}

export function SharedTaskDetailPanel({ task, onClose }: SharedTaskDetailPanelProps) {
  const subscribeToGroup = useSharedGroupStore((s) => s.subscribeToGroup)
  const activeGroupMembers = useSharedGroupStore((s) => s.activeGroupMembers)
  const groupLabels = useSharedGroupStore((s) => s.groupLabels)
  const loadLabels = useSharedGroupStore((s) => s.loadLabels)

  useEffect(() => {
    if (!task.groupId) return
    subscribeToGroup(task.groupId)
    loadLabels(task.groupId)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [task.groupId])

  if (!task.sharedTask || !task.groupId) return null

  return (
    <div className="hidden lg:block w-[400px] flex-shrink-0 rounded-xl border border-base overflow-hidden h-full overflow-y-auto bg-surface-primary shadow-lg">
      <SharedTaskDetailModal
        isOpen={true}
        onClose={onClose}
        task={task.sharedTask}
        groupId={task.groupId}
        members={activeGroupMembers}
        labels={groupLabels}
        canEdit={true}
        panelMode
        groupName={task.groupName}
        groupColor={task.groupColor}
      />
    </div>
  )
}
